import { ArticleExtraData } from "../../../../../../../articlePage/stateInterfaces";
import { OngoingRoofItemMeta } from "../utils/newsFlashUtils";
import { NewsFlashSpecialSlotItem } from "./newsFlashSpecialSlotItem";

interface OngoingRoofEventClusterProps {
    roof: string
    articles: ArticleExtraData[]
    articleIndexes: number[]
    metas: OngoingRoofItemMeta[]
    isLTR: boolean
    languageCode: string
    isFirstInterval: boolean
    highlightingDuration: number
    tickerBottomLink?: string
    tickerBottomTitle?: string
    accordionOpenState?: boolean
    openedItemIndex?: string
    openedItems?: string[]
    onToggleItem?: (id: string) => void
    onLiveUpdatesClick: (roof: string) => void
    openMediaDisplayView: (videoIndex: number, articleId?: string) => void
}

export const OngoingRoofEventCluster = (props: OngoingRoofEventClusterProps) => {
    const { roof, articles, articleIndexes, metas, isLTR, languageCode, isFirstInterval, highlightingDuration,
        tickerBottomLink, tickerBottomTitle, accordionOpenState, openedItemIndex, openedItems,
        onToggleItem, openMediaDisplayView, onLiveUpdatesClick } = props;
    const showFilledDot = metas.some(meta => meta.showFilledRedDot);
    const showUpdatesButton = metas.some(meta => meta.showUpdatesButton);
    const numOfRoofUpdates = metas.reduce((max, meta) => meta.updatesCount > max ? meta.updatesCount : max, 0);

    return (
        <div className={`ongoing-roof-event-cluster ${showFilledDot ? "has-filled-dot" : ""}`}>
            {showFilledDot && <div className="ongoing-cluster-filled-dot" aria-hidden="true" />}

            <div className="ongoing-cluster-header">
                <div className="ongoing-cluster-roof">{roof}</div>

                {showUpdatesButton && (
                    <button className="ongoing-live-updates-label" type="button" onClick={() => onLiveUpdatesClick(roof)}>
                        <span className="label-text">{numOfRoofUpdates} עדכונים</span>
                        <span className="label-arrow" aria-hidden="true" />
                    </button>
                )}
            </div>

            <div className="ongoing-cluster-items">
                {articles.map((article, localIndex) => {
                    const globalIndex = articleIndexes[localIndex];
                    const accordionState = onToggleItem
                        ? (accordionOpenState || article.articleId === openedItemIndex || (openedItems && openedItems.includes(article.articleId)))
                        : accordionOpenState;

                    return (
                        <NewsFlashSpecialSlotItem
                            isLTR={isLTR}
                            nextRoof={null}
                            article={article}
                            previousRoof={null}
                            index={globalIndex}
                            isClusterChild={true}
                            roofOngoingEvent={true}
                            key={article.articleId}
                            languageCode={languageCode}
                            onRowItemToggle={onToggleItem}
                            ongoingMeta={metas[localIndex]}
                            isFirstInterval={isFirstInterval}
                            accordionOpenState={accordionState}
                            tickerBottomLink={tickerBottomLink}
                            tickerBottomTitle={tickerBottomTitle}
                            highlightingDuration={highlightingDuration}
                            openMediaDisplayView={openMediaDisplayView}
                        />
                    );
                })}
            </div>
        </div>
    );
}
